import { createReducer, on } from '@ngrx/store';

import { OddsPreferencePopupActions } from './actions';
import { OddsPreferencePopupState, defaultOddsPreferencePopupState } from './odds-preference-state.model';

export const oddsPreferencePopupReducer = createReducer<OddsPreferencePopupState>(
    defaultOddsPreferencePopupState,
    on(OddsPreferencePopupActions.incrementCounter, (state, _) => {
        return {
            disabled: state.disabled,
            counter: state.counter + 1,
        };
    }),

    on(OddsPreferencePopupActions.initializeState, (_, action) => {
        return {
            disabled: action.disabled,
            counter: 0,
        };
    }),
    on(OddsPreferencePopupActions.setDisabled, (state, action) => {
        return {
            disabled: action.disabled,
            counter: state.counter,
        };
    }),
);
